<!-- Настройки видимости данных одного ресурса в роли. -->
<template>
  <div v-if="dataScope" class="data-scope">
    <PermissionRoleSettingsSection
      v-for="section in dataScope.sections"
      :key="section.key"
      :title="section.title || section.label"
      :description="section.description"
      :help-text="section.help_text"
      :icon="section.icon"
    >
      <div class="data-scope__option-list">
        <PermissionRoleToggleButton
          v-for="option in section.options"
          :key="option.key"
          :label="option.label"
          :selected="option.selected"
          :disabled="disabled"
          @click="$emit('change', option.payload)"
        />
      </div>
    </PermissionRoleSettingsSection>
  </div>
</template>

<script>
import PermissionRoleSettingsSection from "@/components/PermissionRole/SettingsSection.vue";
import PermissionRoleToggleButton from "@/components/PermissionRole/ToggleButton.vue";

export default {
  name: "PermissionRoleDataScopeSettings",

  components: {
    PermissionRoleSettingsSection,
    PermissionRoleToggleButton,
  },

  props: {
    dataScope: {
      type: Object,
      default: null,
    },
    disabled: Boolean,
  },

  emits: ["change"],
};
</script>

<style scoped>
.data-scope {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.data-scope__option-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

@media (max-width: 768px) {
  .data-scope__option-list {
    gap: 10px;
  }
}
</style>
